import {Component, OnInit} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BoardService } from "app/service/board/board.service";

@Component({
  selector: 'app-community-board',
  templateUrl: './community-board.component.html',
  styleUrls: ['./community-board.component.scss'],
  providers: [BoardService]
})
export class CommunityBoardComponent implements OnInit{
  constructor(private boardService: BoardService,
              private route: ActivatedRoute,
              private router: Router,) {
    this.getKeyword();
    this.getCate();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      params => {
        this.location = params['location']  ? params['location'] : '';
        this.search   = params['search']    ? params['search']   : '';
        this.category = params['category']  ? params['category'].split(',') : [];
        this.tag      = params['tag']       ? params['tag']      : '';
        this.active   = params['active']    ? params['active']   : '';
      }
    );
  }

  reload() {
    let url = this.router.url.split('?')[0];

    this.router.navigateByUrl(
      `${url}?page=1` +
      `${this.active ? `&active=${this.active}`: ''}` +
      `${this.location ? `&location=${this.location}`: ''}` +
      `${this.search ? `&search=${this.search}`: ''}` +
      `${this.selectedCate.length ? `&category=${this.selectedCate}`: ''}` +
      `${this.tag ? `&tag=${this.tag}`: ''}`);
  }

  category: string[];
  categories: any[];
  getCate() {
    this.boardService.getCategory().subscribe(
      ({categories}) => {
        this.categories = categories.map(o => ({
          value: o,
          checked: this.category.findIndex(opt => opt == o) != -1
        }))
      }
    )
  }
  onCate() {
    this.category = this.selectedCate;
    this.reload();
  }
  get selectedCate() {
    return this.categories.filter(opt => opt.checked).map(opt => opt.value);
  }

  search: string;
  onSearch(term: string) {
    this.search = term;
    this.reload();
  }

  keywords: string[];
  getKeyword() {
    this.boardService.getCommunityKeyword().subscribe(
      ({keywords}) => this.keywords = keywords
    )
  }
  tag: string;
  onTag(tag: string) {
    if(this.tag === tag) {
      this.tag = ''
    } else {
      this.tag = tag
    }
    this.reload();
  }
  active: string;
  onActive(active: string) {
    if(active === 'all') {
      this.active = ''
    } else {
      this.active = active;
    }
    this.reload();
  }
  location: string;
  onLocation(location: string) {
    this.location = location
    this.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/member/community-board/community-board.component.ts